import React, { useState, useEffect, useRef } from 'react';
import { isNullOrEmptyArray } from '../../util/arrays/empty';
import * as Ui from './numbers.styles';

export default function NumbersPopup({
  // títulos do popup de acordo com o valor selecionado
  names = [],
  // número de linhas a dividir os itens
  rows = 3,
  // valor do item selecionado
  selectedValue,
  // propaga o evento de seleção
  onSelectItem,
  // para o componente filho
  children,
  // Define se o item aparecerá aberto
  openItem,
  // marcador que indica se sera possivel limpar a selecao
  showCleanOption,
}) {
  // states
  const [total, setTotal] = useState(0);
  const [factor, setFactor] = useState(0);
  const [title, setTitle] = useState(null);
  const [isOpen, setIsOpen] = useState(openItem);
  const localRef = useRef();

  // efeito de alteração dos names e números de linhas
  useEffect(() => {
    // total de itens
    if (!isNullOrEmptyArray(names)) {
      const lTotal = names.length;
      const lFactor = Math.floor(lTotal / rows) + ((lTotal % rows) ? 1 : 0);
      setTotal(lTotal);
      setFactor(lFactor);
    }
  }, [names, rows]);

  // efeito de alteração do item selecionado para geração do título
  useEffect(() => {
    if (!isNullOrEmptyArray(names)) {
      if (!selectedValue || selectedValue > names.length) {
        setTitle('Sem correspondência');
      } else {
        setTitle(names[selectedValue - 1].label);
      }
    }
  }, [names, selectedValue]);

  // manipula a seleção do item
  function handleSelectItem(value) {
    if (onSelectItem) onSelectItem(value);
  }

  function handleClickOutside(e) {
    if (localRef.current && !localRef.current.contains(e.target)) {
      setIsOpen(false);
    }
  }

  /**
   * Registrando listeners para fechar automaticamente o
   * menu ao tocar fora do componente
   */
  useEffect(() => {
    // ao tocar fora
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  });

  function renderRadios(rowIndex) {
    const radios = [];
    for (let index = 0; index < factor; index += 1) {
      const value = (rowIndex * factor) + index + 1;
      if (value <= total) {
        radios[index] = (
          <Ui.Radio
            name={'popup'}
            key={`key-${value}`}
            id={value}
            label={value}
            value={value}
            checked={(selectedValue === value)}
            onChange={() => handleSelectItem(value)}
          />
        );
      }
    }
    return radios;
  }

  function renderRows() {
    const radiosRows = [];
    for (let index = 0; index < rows; index += 1) {
      radiosRows[index] = (
        <Ui.Row
          key={`key-row-${index}`}
        >
          {renderRadios(index)}
        </Ui.Row>
      );
    }
    return radiosRows;
  }

  function handleClick() {
    if (!isOpen) {
      setIsOpen(true);
    }
  }

  function handleClose() {
    if (isOpen) {
      setIsOpen(false);
    }
  }

  /**
   * calcula o width baseado nos parametros
   * @param {*} columnFactor numero de colunas
   * @param {*} minWidth largura minima do container
   * @param {*} minWidth a largura da coluna
   */
  function calculateWidth(columnFactor, minWidth, columnWidth) {
    const relativeWidth = columnFactor * columnWidth;
    return relativeWidth < minWidth ? minWidth : relativeWidth;
  }

  // Calcula width do box como todo
  function calculateContainerWidth() {
    return calculateWidth(factor, 190, 40);
  }

  // Calcula width do header
  function calculateHeaderWidth() {
    return calculateWidth(factor, 170, 37);
  }

  return (
    <>
      <Ui.Clicable onClick={(e) => handleClick(e)} ref={localRef}>
        {children}
        {isOpen && (
          <Ui.Container containerWidth={calculateContainerWidth()}>
            <Ui.Head headWidth={calculateHeaderWidth()}>
              {title}
              <Ui.Close onClick={(e) => handleClose(e)} title="Fechar" className="settings-closer">&times;</Ui.Close>
            </Ui.Head>
            <Ui.InnerContainer>
              {renderRows()}
              {showCleanOption ? <p className="selection-clean-btn" onClick={() => handleSelectItem(null)} title="Limpa a seleção feita para esta alternativa">Limpar seleção</p> : null}
            </Ui.InnerContainer>
          </Ui.Container>
        )}
      </Ui.Clicable>
    </>
  );
}
